import { type VariantProps, cva } from "class-variance-authority";
import clsx from "clsx";
import type { PropsWithChildren } from "react";

import { Typography } from "@/components/ui/text/Typography/Typography";

export const radioOrCheckbox = cva("flex items-center justify-center border-2", {
  variants: {
    variant: {
      default: [
        "border-secondary-75",
        "cursor-pointer",
        "group-disabled:border-secondary-75",
        "group-hover:border-secondary-75",
        "group-pressed:border-secondary-100",
        "group-selected:border-secondary-75",
        "group-selected:bg-secondary-75",
        "group-selected:group-hover:bg-secondary-75",
        "group-selected:group-hover:border-secondary-75",
        "group-selected:group-pressed:bg-secondary-100",
        "group-selected:group-pressed:border-secondary-100",
        "group-indeterminate:border-secondary-75",
        "group-indeterminate:bg-secondary-75",
        "group-indeterminate:group-hover:bg-secondary-75",
        "group-indeterminate:group-hover:border-secondary-75",
        "group-indeterminate:group-pressed:bg-secondary-100",
        "group-indeterminate:group-pressed:border-secondary-100",
      ],
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export type RadioOrCheckboxVariantProps = VariantProps<typeof radioOrCheckbox>;

export const radioOrCheckboxIndicatorClass = "group flex items-center gap-2";

export interface RadioOrCheckboxLabelProps extends PropsWithChildren {
  className?: string;
}

export const RadioOrCheckboxLabel = ({ children, className }: RadioOrCheckboxLabelProps) => {
  return (
    <Typography
      className={clsx("text-white", className)}
      size="labels-xs"
      variant="prominent-2"
    >
      {children}
    </Typography>
  );
};
